module.exports = __webpack_public_path__ + "static/media/cachorro.2588a748.svg";